import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import FormStepperAccordion from "./FormStepper.accordion";
import FormStepperSlider from "./FormStepper.slider";
import FormStepperRouter from "./FormStepper.router";
import FormValidation from "../../../../modules/forms/Validation/FormValidation";
import Calculator from "../../../../modules/forms/Templates/Calculator/Calculator";

gsap.registerPlugin(ScrollTrigger);

const FormStepper = {
    component: 'Slider',
    // component: 'Accordion',

    init(config) {
        this.config = config;
        this.el = $('[component="FormStepper"]');
        if (!this.el.length) return;

        this.Slider = FormStepperSlider;
        this.Accordion = FormStepperAccordion;
        this.Router = FormStepperRouter;

        this.component = config.component;
        this.adaptiveHeight = config.adaptiveHeight;
        this.el.attr('layout', this.component);
        this.el.attr('navigation', config.navigation ? "true" : "false");
        this.el.attr('buttons', config.buttons);

        this.slides = this.el.find('.slide');
        this.tabs = this.el.find('.tab');
        this.main = this.el.find('main');
        this.slides = this.el.find('.slide');
        this.footer = this.el.find('footer');
        this.buttons = this.footer.find('button.back, button.next');

        this.count = this.slides.length;
        this.current = 1;

        this.Slider.init(this);
        this.Accordion.init(this);
        this[this.component].onLoad();

        if (this.config.useRouter) this.Router.init(this);

        this.bind();
        setTimeout(() => {
            // this.resize();
        }, 1)


    },

    bind() {
        this.el.find('.tab').click((evt) => {
            this.current = parseInt($(evt.currentTarget).attr('order'));
            this[this.component].show(this.current);
            if (this.config.useRouter) this.Router.route(this.current);

            if (this.adaptiveHeight) {
                setTimeout(() => this.setHeight(), 10)
            }
        })

        this.buttons.click((evt) => {
            const button = $(evt.currentTarget);
            const direction = parseInt(button.attr('direction'));
            if (button.is('.next')) {
                if (!FormValidation.check(this.active) && this.config.validateForms) return;
            }
            this.slide(direction)
        })

        this.el.find('.nav > div').click((evt) => {
            this.component = $(evt.currentTarget).attr('component');
            this.el.attr('layout', this.component);
            this.resize();
        })
    },

    slide(direction) {
        this.current += direction;

        if (this.current > this.count) {
            this.current = this.count;
            return;
        }

        if (this.current < 1) {
            this.current = 1;
            return;
        }
        this.tabs.filter('[order="' + this.current + '"]').trigger('click');

        if (this.config.useRouter) {
            this.Router.route(this.current);
        }
    },

    setHeight() {
        const height = this.slides.filter('.active').outerHeight();
        console.log(this.slides.filter('.active'), height)
        gsap.to(this.main, {height: height, duration: 0.5})
    },

    arrangeButtons() {
        this.footer.removeClass('start end');
        if (this.current === this.count) {
            this.footer.addClass('end');
        }

        if (this.current === 1) {
            this.footer.addClass('start');
        }
        this.el.attr('slide', this.current)
    },

    resize() {
        this.el.attr('layout', this.component);
        this[this.component].prepare();
        this[this.component].resize();
    },
}

export default FormStepper;